import http from "../../http";

const functions = {
    getList(param){
        return http.get("/gateway/api/auth/pc/systemFunction/selectByNoPage", param);
    },
}
export default functions